export const VISUAL_MULTIPLIER = 6;
